import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06b44999")

_pushScopeId("data-v-06b44999")
const _hoisted_1 = { class: "lost-in-paradise" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Lost in Paradise", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AnimationToggle = _resolveComponent("AnimationToggle")!
  const _component_MarkeredBackground = _resolveComponent("MarkeredBackground")!
  const _component_MarkeredPath = _resolveComponent("MarkeredPath")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AnimationToggle, {
      animationToggle: _ctx.animationToggle,
      "onUpdate:animationToggle": _cache[1] || (_cache[1] = ($event: any) => (_ctx.animationToggle = $event))
    }, null, 8, ["animationToggle"]),
    _createVNode(_component_MarkeredBackground, {
      class: "title",
      stroke: '#252226',
      fill: '#46c1d0',
      animate: _ctx.animationToggle
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["animate"]),
    _createVNode(_component_MarkeredPath, {
      stroke: '#252226',
      fill: '#ee5456',
      animate: _ctx.animationToggle,
      path: _ctx.path,
      height: 250,
      width: 250
    }, null, 8, ["animate", "path"])
  ]))
})